import { useEffect } from "react";
import { appStore } from "src/framework/store/AppStore";
import { EdicaoLayoutPersonalizadoHibrido } from "src/components/projetos/edicao/layouts/EdicaoLayoutPersonalizadoHibrido";
import { ProjetosFormInicialPersonalizadoHibrido } from "src/components/projetos/personalizados_hibrido/containers/Formulario/FormInicial";

const PAGE_TITLE = 'Clonar projeto híbrido'

const ProjetosFormInicialPersonalizadoHibridoClonar = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])
  
  return (
    <EdicaoLayoutPersonalizadoHibrido clonarProjeto>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetosFormInicialPersonalizadoHibrido />
          </div>
        </div>
      </div>
    </EdicaoLayoutPersonalizadoHibrido>
  );
};

export { ProjetosFormInicialPersonalizadoHibridoClonar };